var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M53.9795 18.7735C52.7615 15.9374 50.2929 12.8754 48.3563 11.9067C49.9336 14.8987 50.8459 17.9019 51.1947 20.1419C51.1947 20.1351 51.1971 20.1475 51.1994 20.1667L51.2041 20.1961C53.85 27.1362 52.408 34.1938 50.3314 38.5067C47.1186 45.1792 39.3419 52.0177 27.1658 51.6824C14.011 51.3234 2.42178 41.8791 0.258868 29.5049C-0.13545 27.554 0.258868 26.5638 0.457194 24.9798C0.215703 26.1991 0.12354 26.5536 0.00221117 28.7225L-0.00012207 28.8614C-0.00012207 43.8436 12.5527 55.9919 28.0361 55.9919C41.9038 55.9919 53.4171 46.2484 55.6734 33.4531L55.8017 32.4065C56.3582 27.7549 55.7399 22.8628 53.9818 18.7735H53.9795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M28.0886 23.6453C28.042 24.3205 25.5804 26.6485 24.7171 26.6485C16.7444 26.6485 15.4506 31.3148 15.4506 31.3148C15.8041 35.2438 18.6308 38.4819 22.0537 40.1946C22.21 40.2737 22.3687 40.3414 22.5262 40.4125C22.7974 40.5289 23.0721 40.6377 23.3498 40.7388C24.5238 41.141 25.7535 41.3705 26.9978 41.4196C40.9716 42.0541 43.6805 25.2519 33.5951 20.3745C36.1768 19.9398 38.8565 20.9447 40.3545 21.9631C37.9046 17.8173 33.3256 15.0195 28.07 15.0195C27.7375 15.0195 27.412 15.0466 27.0853 15.0681C24.273 15.2553 21.5841 16.2582 19.3693 17.946C19.7963 18.296 20.2793 18.7634 21.2942 19.7332C23.1958 21.5464 28.0758 23.4252 28.0863 23.6453H28.0886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.9795 18.7735C52.7615 15.9374 50.2929 12.8755 48.3563 11.9068C49.9336 14.8987 50.8459 17.9019 51.1947 20.1419L51.2006 20.187C48.0297 12.5401 42.6551 9.45563 38.2651 2.74129L37.6048 1.70259C37.4944 1.51943 37.3912 1.33225 37.2956 1.14146C37.1134 0.800903 36.9728 0.440947 36.8768 0.0688836C36.8775 0.0511003 36.8713 0.033698 36.8595 0.0201118C36.8476 0.00652558 36.8309 -0.00225734 36.8126 -0.00450326C36.7955 -0.0092411 36.7773 -0.0092411 36.7601 -0.00450326L36.7461 0.00339994L36.7263 0.0146902L36.738 -0.00111617C29.6951 3.99113 27.3058 11.375 27.0853 15.0714C24.2731 15.2583 21.5842 16.2608 19.3693 17.9482C19.1376 17.7586 18.8953 17.5815 18.6437 17.4175C18.0044 15.254 17.977 12.964 18.5643 10.7868C15.6851 12.0558 13.4429 14.0609 11.8154 15.8335H11.8038C10.692 14.4719 10.7701 9.97724 10.8331 9.03902C10.8215 8.98031 10.0048 9.44886 9.89749 9.51886C8.91657 10.1963 7.99953 10.9565 7.1571 11.7905C6.19868 12.7314 5.32301 13.748 4.5392 14.8298L4.53804 14.8332V14.8298C2.73513 17.3021 1.45638 20.0957 0.775681 23.0491L0.738349 23.2298C0.635037 23.7925 0.542857 24.3572 0.46186 24.9233L0.456027 24.982C0.210466 26.2176 0.0584011 27.4689 0.00104455 28.7259L-0.00012207 28.8614C-0.00012207 43.8436 12.5527 55.9919 28.0361 55.9919C41.9038 55.9919 53.4171 46.2484 55.6734 33.4531L55.8017 32.4065C56.3582 27.7549 55.7399 22.8628 53.9818 18.7735H53.9795ZM21.664 40.0105C21.7959 40.0704 21.9207 40.137 22.0537 40.1957L22.0724 40.207C21.9352 40.1436 21.7991 40.0781 21.664 40.0105ZM51.2017 20.1927L51.1982 20.1667L51.2029 20.1961L51.2017 20.1927Z",
    fill: "url(#paint0_linear_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_2",
    d: "M53.9795 18.7735C52.7615 15.9374 50.2929 12.8754 48.3563 11.9067C49.9336 14.8987 50.8459 17.9019 51.1947 20.1419C51.1947 20.1351 51.1971 20.1475 51.1994 20.1667L51.2041 20.1961C53.85 27.1362 52.408 34.1938 50.3314 38.5067C47.1186 45.1792 39.3419 52.0177 27.1658 51.6824C14.011 51.3234 2.42178 41.8791 0.258868 29.5049C-0.13545 27.554 0.258868 26.5638 0.457194 24.9798C0.215703 26.1991 0.12354 26.5536 0.00221117 28.7225L-0.00012207 28.8614C-0.00012207 43.8436 12.5527 55.9919 28.0361 55.9919C41.9038 55.9919 53.4171 46.2484 55.6734 33.4531L55.8017 32.4065C56.3582 27.7549 55.7399 22.8628 53.9818 18.7735H53.9795Z",
    fill: "url(#paint1_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c_3",
    d: "M53.9795 18.7735C52.7615 15.9374 50.2929 12.8754 48.3563 11.9067C49.9336 14.8987 50.8459 17.9019 51.1947 20.1419C51.1947 20.1351 51.1971 20.1475 51.1994 20.1667L51.2041 20.1961C53.85 27.1362 52.408 34.1938 50.3314 38.5067C47.1186 45.1792 39.3419 52.0177 27.1658 51.6824C14.011 51.3234 2.42178 41.8791 0.258868 29.5049C-0.13545 27.554 0.258868 26.5638 0.457194 24.9798C0.215703 26.1991 0.12354 26.5536 0.00221117 28.7225L-0.00012207 28.8614C-0.00012207 43.8436 12.5527 55.9919 28.0361 55.9919C41.9038 55.9919 53.4171 46.2484 55.6734 33.4531L55.8017 32.4065C56.3582 27.7549 55.7399 22.8628 53.9818 18.7735H53.9795Z",
    fill: "url(#paint2_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M40.3557 21.9632L40.5307 22.0874C39.8271 20.879 38.9508 19.7725 37.928 18.8008C29.2121 10.3681 35.6402 0.515081 36.7252 0.0149215L36.7368 0.000244141C29.694 3.99136 27.3047 11.3763 27.0854 15.0705C27.412 15.0479 27.7387 15.022 28.07 15.022C33.3256 15.022 37.9046 17.8186 40.3545 21.9655L40.3557 21.9632Z",
    fill: "url(#paint3_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g_2",
    d: "M28.0886 23.6453C28.042 24.3205 25.5804 26.6485 24.7171 26.6485C16.7444 26.6485 15.4506 31.3148 15.4506 31.3148C15.8041 35.2438 18.6308 38.4819 22.0537 40.1946C22.21 40.2737 22.3687 40.3414 22.5262 40.4125C22.7974 40.5289 23.0721 40.6377 23.3498 40.7388C24.5238 41.141 25.7535 41.3705 26.9978 41.4196C40.9716 42.0541 43.6805 25.2519 33.5951 20.3745C36.1768 19.9398 38.8565 20.9447 40.3545 21.9631C37.9046 17.8173 33.3256 15.0195 28.07 15.0195C27.7375 15.0195 27.412 15.0466 27.0853 15.0681C24.273 15.2553 21.5841 16.2582 19.3693 17.946C19.7963 18.296 20.2793 18.7634 21.2942 19.7332C23.1958 21.5464 28.0758 23.4252 28.0863 23.6453H28.0886Z",
    fill: "url(#paint4_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g_3",
    d: "M28.0886 23.6453C28.042 24.3205 25.5804 26.6485 24.7171 26.6485C16.7444 26.6485 15.4506 31.3148 15.4506 31.3148C15.8041 35.2438 18.6308 38.4819 22.0537 40.1946C22.21 40.2737 22.3687 40.3414 22.5262 40.4125C22.7974 40.5289 23.0721 40.6377 23.3498 40.7388C24.5238 41.141 25.7535 41.3705 26.9978 41.4196C40.9716 42.0541 43.6805 25.2519 33.5951 20.3745C36.1768 19.9398 38.8565 20.9447 40.3545 21.9631C37.9046 17.8173 33.3256 15.0195 28.07 15.0195C27.7375 15.0195 27.412 15.0466 27.0853 15.0681C24.273 15.2553 21.5841 16.2582 19.3693 17.946C19.7963 18.296 20.2793 18.7634 21.2942 19.7332C23.1958 21.5464 28.0758 23.4252 28.0863 23.6453H28.0886Z",
    fill: "url(#paint5_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.0627 17.045C18.2579 17.1669 18.4516 17.2911 18.6437 17.4176C18.0046 15.2536 17.9776 12.9632 18.5655 10.7856C15.6839 12.0558 13.444 14.0598 11.8166 15.8324C11.9508 15.829 16.0164 15.7579 18.0627 17.045Z",
    fill: "url(#paint6_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.258872 29.505C2.42295 41.8792 14.011 51.3235 27.1647 51.6837C39.3407 52.0179 47.1186 45.1782 50.3314 38.5079C52.408 34.195 53.85 27.1386 51.2041 20.1973V20.1951L51.1994 20.168C51.1971 20.1488 51.1947 20.1363 51.1947 20.1431L51.2006 20.1883C52.1957 26.4725 48.8907 32.5602 43.7284 36.6766L43.7132 36.7105C33.6511 44.6397 24.023 41.4942 22.0724 40.2071C21.9353 40.1434 21.7992 40.0779 21.664 40.0106C15.7983 37.2976 13.3752 32.1255 13.8943 27.6895C8.94203 27.6895 7.25277 23.6476 7.25277 23.6476C7.25277 23.6476 11.6999 20.5789 17.561 23.2468C22.9893 25.7194 28.0875 23.6476 28.0875 23.6465C28.0758 23.4263 23.197 21.5465 21.2954 19.7344C20.2781 18.7634 19.7963 18.2983 19.3681 17.9472C19.1364 17.7576 18.8942 17.5805 18.6425 17.4165C18.4502 17.2903 18.2565 17.1661 18.0615 17.0439C16.0164 15.7568 11.9484 15.8291 11.8143 15.8325H11.8026C10.6908 14.4697 10.769 9.97509 10.832 9.03573C10.8203 8.97928 10.0037 9.44557 9.89633 9.5167C8.91541 10.1942 7.99837 10.9543 7.15594 11.7883C6.19752 12.7292 5.32185 13.7459 4.53804 14.8277L4.53687 14.831V14.8277C2.73397 17.3 1.45522 20.0936 0.774518 23.047C0.762852 23.1057 -0.234609 27.3192 0.256539 29.505H0.258872Z",
    fill: "url(#paint7_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.9267 18.8017C38.9495 19.7731 39.8257 20.8791 40.5295 22.0872L40.9495 22.4214C47.3075 28.0891 43.9757 36.1052 43.726 36.6765C48.8895 32.5601 52.1933 26.4724 51.1982 20.1882C48.0297 12.5401 42.6551 9.45563 38.2651 2.74129L37.6048 1.70259C37.4944 1.51943 37.3912 1.33225 37.2956 1.14146C37.1134 0.800903 36.9728 0.440947 36.8768 0.0688836C36.8775 0.0511003 36.8713 0.033698 36.8594 0.0201118C36.8476 0.00652558 36.8309 -0.00225734 36.8126 -0.00450326C36.7955 -0.0092411 36.7773 -0.0092411 36.7601 -0.00450326L36.7461 0.00339994L36.7263 0.0146902C35.6413 0.51485 29.2132 10.3679 37.9279 18.8017H37.9267Z",
    fill: "url(#paint8_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.9506 22.4202C40.8164 22.3025 40.6762 22.1914 40.5307 22.0871L40.3557 21.9629C38.8589 20.9468 36.1792 19.9397 33.5963 20.3744C43.6805 25.254 40.9728 42.0551 26.999 41.4195C25.7547 41.3703 24.525 41.1408 23.351 40.7386C23.0733 40.6374 22.7987 40.5286 22.5274 40.4124C22.368 40.3435 22.2105 40.2708 22.0549 40.1945L22.0735 40.2057C24.0218 41.4928 33.6511 44.6372 43.7144 36.7091L43.7295 36.6753C43.978 36.104 47.3087 28.0879 40.953 22.4202H40.9506Z",
    fill: "url(#paint9_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.4506 31.316C15.4506 31.316 16.7456 26.6497 24.7171 26.6497C25.5804 26.6497 28.042 24.3216 28.0887 23.6465C28.1353 22.9713 22.9905 25.7194 17.5622 23.2468C11.7011 20.5789 7.25397 23.6465 7.25397 23.6465C7.25397 23.6465 8.94324 27.6884 13.8955 27.6884C13.3764 32.1255 15.7995 37.2964 21.6652 40.0095C21.7971 40.0693 21.9196 40.1359 22.0549 40.1946C18.6309 38.4819 15.8041 35.245 15.4518 31.3148L15.4506 31.316Z",
    fill: "url(#paint10_radial_2757_754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M53.9795 18.7735C52.7615 15.9374 50.2929 12.8755 48.3563 11.9068C49.9336 14.8987 50.8459 17.9019 51.1947 20.1419L51.2006 20.187C48.0297 12.5401 42.6551 9.45563 38.2651 2.74129L37.6048 1.70259C37.4944 1.51943 37.3912 1.33225 37.2956 1.14146C37.1134 0.800903 36.9728 0.440947 36.8768 0.0688836C36.8775 0.0511003 36.8713 0.033698 36.8595 0.0201118C36.8476 0.00652558 36.8309 -0.00225734 36.8126 -0.00450326C36.7955 -0.0092411 36.7773 -0.0092411 36.7601 -0.00450326L36.7461 0.00339994L36.7263 0.0146902L36.738 -0.00111617C29.6951 3.99113 27.3058 11.375 27.0853 15.0714C27.412 15.0488 27.7386 15.0229 28.0711 15.0229C33.3268 15.0229 37.9057 17.8195 40.3556 21.9641C38.8577 20.948 36.1791 19.9409 33.5951 20.3756C43.6794 25.2553 40.9716 42.0563 26.9978 41.4207C25.7535 41.3716 24.5238 41.1421 23.3498 40.7399C23.0721 40.6387 22.7975 40.5299 22.5262 40.4136C22.3668 40.3448 22.2093 40.2721 22.0537 40.1957L22.0735 40.207C21.9365 40.1433 21.8004 40.0778 21.6652 40.0105C21.7959 40.0704 21.9195 40.137 22.0537 40.1957C18.6297 38.483 15.8029 35.246 15.4506 31.3159C15.4506 31.3159 16.7432 26.6496 24.7159 26.6496C25.5792 26.6496 28.0408 24.3216 28.0875 23.6464C28.0758 23.4262 23.1993 21.5464 21.2954 19.7343C20.2804 18.7633 19.7963 18.2982 19.3705 17.9471C19.1384 17.7575 18.8957 17.5803 18.6437 17.4164C18.0048 15.2528 17.9778 12.9628 18.5655 10.7856C15.6839 12.0547 13.444 14.0598 11.8166 15.8324H11.8049C10.6931 14.4696 10.7713 9.97611 10.8343 9.03563C10.8226 8.97918 10.006 9.44547 9.89866 9.5166C8.91774 10.1941 8.00069 10.9542 7.15827 11.7882C6.20025 12.7292 5.32497 13.7458 4.54154 14.8275L4.54037 14.8309V14.8275C2.73746 17.2999 1.45871 20.0935 0.778014 23.0469L0.740683 23.2275C0.621571 23.7956 0.513833 24.3659 0.417528 24.938C0.415195 24.9583 0.419862 24.9188 0.417528 24.938C0.200902 26.1907 0.0626001 27.4548 0.00337779 28.7236L-0.00012207 28.8614C-0.00012207 43.8436 12.5527 55.9919 28.0361 55.9919C41.9038 55.9919 53.4171 46.2484 55.6734 33.4531L55.8017 32.4065C56.3582 27.7549 55.7399 22.8628 53.9818 18.7735H53.9795ZM51.1982 20.1667L51.2029 20.1961V20.1938L51.1982 20.1667Z",
    fill: "url(#paint11_linear_2757_754)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2757_754",
    x1: 2516290,
    y1: 447020,
    x2: 271096,
    y2: 2685000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.01649e+06 -292868) scale(2.95322e+06 2.9061e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.15879e+06 908167) scale(3.02705e+06 2.9061e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332395 -136499) scale(969407 1.59249e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291924 1.49807e+06) scale(1.28255e+06 1.36051e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600247 448982) scale(681034 802698)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(738359 -341533) scale(1.01962e+06 990477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27196e+06 -900850) scale(4.86849e+06 3.95499e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376670 50074.1) rotate(76.9889) scale(1.49695e+06 6.67085e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221627 -473710) scale(2.79527e+06 2.65735e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2757_754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.7093e+06 -415411) scale(3.35957e+06 2.90859e+06)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2757_754",
    x1: 2307200,
    y1: 403760,
    x2: 519120,
    y2: 2422560,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFf);
export default __webpack_public_path__ + "static/media/FF.b21c12bce3cbec648f99c1f33d373a92.svg";
export { ForwardRef as ReactComponent };